import React from "react"
import {Route, Redirect} from "react-router-dom"
import {RouteComponentProps} from "react-router-dom"

import {NestedRoute} from "@irati/utils/history/routing"

import AppContainer from "@irati/ui/src/AppContainer"

import Logout from "../../containers/Logout"
import Login from "../../containers/Login/Login"
import ForgotPassword from "../../containers/ForgotPassword/ForgotPassword"
import ResetPassword from "../../containers/ResetPassword/ResetPassword"
import CheckEmail from "../../components/CheckEmail"
import SelfSignUp from "../../components/SelfSignUp/SelfSignUp"
import LoginSamlIDP from "../../containers/Login/LoginSamlIDP"
import LoginCode from "../../containers/Login/LoginCode"
import WorkOSIntegrationsLink from "../../containers/WorkOSIntegrationsLink"

interface Props extends RouteComponentProps {}

const Welcome: React.FC<Props> = ({match, location}) => {
  if (location.pathname === "/welcome/logout") {
    // <AppContainer /> wrapper is making infinite loops for logout route
    return <Route exact path="/welcome/logout" component={Logout} />
  }

  return (
    <AppContainer>
      <Route exact path="/welcome" render={() => <Redirect to="/welcome/login" />} />
      <NestedRoute unauthed exact match={match.url} path="/login" title="Login" component={Login} />
      <NestedRoute unauthed exact match={match.url} path="/login/idp" title="Login" component={LoginSamlIDP} />
      <NestedRoute unauthed exact match={match.url} path="/login/code" title="Login via code" component={LoginCode} />
      <NestedRoute unauthed match={match.url} path="/login/check-email" title="Check Email" component={CheckEmail} />
      <NestedRoute unauthed match={match.url} path="/login/forgotten-password" title="Forgot Password" component={ForgotPassword} />
      <NestedRoute noauth match={match.url} path="/login/reset-password" title="Reset Password" component={ResetPassword} />
      <NestedRoute unauthed match={match.url} path="/signup" component={SelfSignUp} />
      <NestedRoute
        noauth
        match={match.url}
        path="/workOS-integrations-link"
        title="WorkOS Integration Link"
        component={WorkOSIntegrationsLink} />
    </AppContainer>
  )
}

export default Welcome
